import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"
import { Container, Row, Col} from 'react-bootstrap';
import Clip from 'Components/Clip/Clip'
import './Clipsarea.css';


const Clipsarea = observer(
  class Clipsarea extends Component {
	
		pagin = [];
		offset = 0;
		gotoPage = (o) => {
			this.props.setcritcb({offset:o});
		}
		
		parseSearchres = (sr) => {
			let clips = [];
			this.pagin = [];
			this.offset = sr.offset;
			let lastpageoffset = Math.floor(sr.count / sr.limit) * sr.limit;//das offset fuer die letze seite
			let page = Math.ceil((sr.offset+1) / sr.limit);
			let pages = Math.ceil(sr.count / sr.limit);
			if(page > 1) this.pagin.push({'l':'<','o':0,'k':'1'});
			if(page > 1) this.pagin.push({'l':'1','o':0,'k':'2'});
			if(page > 3) this.pagin.push({'l':'. . .','o':false,'k':'3'});
			if(page > 2) this.pagin.push({'l':page-1,'o':sr.offset-sr.limit,'k':'4'});
			this.pagin.push({'l':page,'o':sr.offset,'k':'5'});
			if(page < pages-1) this.pagin.push({'l':page+1,'o':sr.offset+sr.limit,'k':'6'});
			if(page < pages-2) this.pagin.push({'l':'. . .','o':false,'k':'7'});
			if(page < pages) this.pagin.push({'l':pages,'o':lastpageoffset,'k':'8'});
			if(page < pages) this.pagin.push({'l':'>','o':sr.offset+sr.limit,'k':'9'});
			if(sr.objects) {
				clips = sr.objects.asArray();
				clips = clips.sort(function(a,b){return (a.data.metadata.fields.txt13 > b.data.metadata.fields.txt13) ? -1 : 1});
				return clips;
			}
			return false;
		}
			
    render() {
			let clips = this.parseSearchres(this.props.searchres);
			if(clips === false) return null;
			if(clips.length < 1) return <Row><Col className="noclipsfound">Aucune vidéo ne correspond à la recherche</Col></Row>;
			return  (
				<>
					<Row>{clips.map(c => {return <Clip  clipclickcb={this.props.clipclickcb}  key={c.getId()} cl={c} />})}</Row>
					<Row className="paginrow">
					 <Col>
					 </Col>
					 <Col className="pagincol" xs={4}>
						{this.pagin.length > 1 && this.pagin.map(
							p => {
								if(p.l === '<' || p.l === '>') return (<div className="pagiitem brackets" key={p.k} onClick={()=>{ this.gotoPage(p.o) }}>{p.l}</div>)
								if(p.o === false) return (<div className="pagiitem dots" key={p.k}>{p.l}</div>)
								if(p.o == this.offset) return (<div className="pagiitem current" key={p.k}>{p.l}</div>)
								return <div className="pagiitem" key={p.k} onClick={()=>{ this.gotoPage(p.o) }} >{p.l}</div>
							}
						)}
					 </Col>
					</Row>
				</>
				
			)
    }
		
  }
)

export default Flow.injectFlow(Clipsarea);